import { defaultFilterDateRange } from '@/shared/utils/date-range';
const EMPTY_CHART_SERIES = { labels: [], data: [] };
function normalizeChartSeries(raw) {
    if (!raw || typeof raw !== 'object') {
        return { ...EMPTY_CHART_SERIES };
    }
    const chart = raw;
    const labels = Array.isArray(chart.labels) ? chart.labels.map(String) : [];
    const data = Array.isArray(chart.datasets?.[0]?.data)
        ? chart.datasets[0].data.map((n) => Number(n) || 0)
        : [];
    return { labels, data };
}
/** Coerce `/api/kases/dashboard` payload into the shape used by the dashboard UI. */
export function normalizeDashboardAnalytics(raw) {
    const data = raw && typeof raw === 'object' ? raw : {};
    return {
        totalCases: Number(data.totalCases) || 0,
        openCases: Number(data.openCases) || 0,
        closedCases: Number(data.closedCases) || 0,
        resolutionRate: Number(data.resolutionRate) || 0,
        charts: {
            byProvince: normalizeChartSeries(data.casesByProvince),
            byDistrict: normalizeChartSeries(data.casesByDistrict),
            byIssue: normalizeChartSeries(data.casesByIssue),
        },
    };
}
export function defaultDashboardDateRange() {
    return defaultFilterDateRange();
}
export function toDateParam(d) {
    if (!d)
        return undefined;
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
